<script lang="ts">
    // set 404 for ssr
    if (typeof window === "undefined") {
        // @ts-ignore
        if (context) context.is404 = true
    }
</script>

<svelte:head>
    <meta name="robots" content="noindex" />
    <meta http-equiv="refresh" content="5; URL=/" />
</svelte:head>

<section class="section_padding">
    <div class="container">
        <h1>404</h1>
        <h2>Seite nicht gefunden - Site not found</h2>
        <p>&nbsp;</p>
        <p>Sie werden in 5 Sekunden auf die Startseite weitergeleitet.</p>
    </div>
</section>
